export const Icons = {
  paymentIcon: PaymentIcon,
};

export function PaymentIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 13q-1.25 0-2.125-.875T11 10t.875-2.125T14 7t2.125.875T17 10t-.875 2.125T14 13m-7 3q-.825 0-1.412-.587T5 14V6q0-.825.588-1.412T7 4h14q.825 0 1.413.588T23 6v8q0 .825-.587 1.413T21 16zm2-2h10q0-.825.588-1.412T21 12V8q-.825 0-1.412-.587T19 6H9q0 .825-.587 1.413T7 8v4q.825 0 1.413.588T9 14m11 6H3q-.825 0-1.412-.587T1 18V7h2v11h17zM7 14V6z"
      ></path>
    </svg>
  );
}



export function MaterialSymbolsCardMembershipOutline(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill="currentColor"
        d="M4 13v2h16v-2zM4 2h16q.825 0 1.413.588T22 4v11q0 .825-.587 1.413T20 17h-4v5l-4-2l-4 2v-5H4q-.825 0-1.412-.587T2 15V4q0-.825.588-1.412T4 2m0 8h16V4H4zm0 5V4z"
      />
    </svg>
  );
}

export function TdesignUserVip(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {/* Icon from TDesign Icons by TDesign - https://github.com/Tencent/tdesign-icons/blob/main/LICENSE */}
      <g fill="none">
        <path d="M16 7.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0m5 7h-6l-1.5 3l4.5 5l4.5-5z" />
        <path
          stroke="currentColor"
          strokeLinecap="square"
          strokeWidth="2"
          d="M10 15H8a5 5 0 0 0-5 5v1h7.05M16 7.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="2"
          d="M21 14.5h-6l-1.5 3l4.5 5l4.5-5z"
        />
      </g>
    </svg>
  );
}


export function CarbonPartitionAuto(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      {...props}
    >
      {/* Icon from Carbon by IBM - undefined */}
      <path
        fill="currentColor"
        d="M26 19c-2.206 0-4 1.794-4 4c0 .684.188 1.317.492 1.88A11 11 0 0 1 16 27C9.935 27 5 22.065 5 16H3c0 7.168 5.832 13 13 13a12.98 12.98 0 0 0 7.843-2.642A3.97 3.97 0 0 0 26 27c2.206 0 4-1.794 4-4s-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2s2 .898 2 2s-.897 2-2 2M16 3a12.98 12.98 0 0 0-7.843 2.642A3.97 3.97 0 0 0 6 5C3.794 5 2 6.794 2 9s1.794 4 4 4s4-1.794 4-4c0-.684-.188-1.317-.492-1.88A11 11 0 0 1 16 5c6.065 0 11 4.935 11 11h2c0-7.168-5.832-13-13-13M6 11c-1.103 0-2-.897-2-2s.897-2 2-2s2 .898 2 2s-.897 2-2 2"
      />
    </svg>
  );
}